import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  AppBar,
  Divider,
  IconButton,
  Menu,
  MenuItem,
  Toolbar,
  Tooltip,
  Typography,
} from "@material-ui/core";
import classNames from "classnames";
import { useState, useCallback, useContext } from "react";
import { DefaultProfile, StocqLogo } from "../../../images";
import Image from "../image/image";
import styles from "./header.module.scss";
import KeyboardArrowDownRoundedIcon from "@material-ui/icons/KeyboardArrowDownRounded";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { useApi, useAuth, useRouter } from "hooks";
import { redirectTo } from "utils";
import { logout } from "apis";
import { Path } from "enums";
import { AppContext, StationContext } from "contexts";
import { locale } from "localization/en";

const Header = ({ onClick }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const { fetchStation, station } = useContext(StationContext) || {};
  const { stationCodes } = useAuth();
  const { toggleLoading } = useContext(AppContext);
  const { history } = useRouter();

  const { request: logoutRequest } = useApi({ api: logout });

  const logoutCb = useCallback(async () => {
    toggleLoading(true);
    await logoutRequest();
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    toggleLoading(false);
    redirectTo(Path.Auth);
  }, [logoutRequest, toggleLoading]);

  const handleOpen = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const UserSwitchStations = useCallback(() => {
    const handleOnClickStationMenu = async (station) => {
      if (station.stationId) localStorage.setItem("stationId", station.stationId);
      await fetchStation();
      history.push(Path.ShiftRecords);
      handleClose();
    };

    if (!stationCodes.stations?.length) return null;

    const stations = stationCodes.stations.sort((a, b) => a.name.localeCompare(b.name));

    return (
      <>
        <Accordion className={styles.accordion} elevation={0}>
          <MenuItem className={classNames(styles.menuItem, styles.menuItemWithHeight)}>
            <AccordionSummary
              className={styles.accordionSummary}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="station-switch-content"
              id="station-switch-header"
            >
              <span>{locale.switchStations}</span>
            </AccordionSummary>
          </MenuItem>
          <AccordionDetails className={styles.accordionDetails}>
            {stations.map((station) => (
              <Tooltip key={station.stationId} title={station.name} placement="right">
                <MenuItem
                  className={classNames(styles.menuItem, styles.menuItemIndented)}
                  onClick={() => handleOnClickStationMenu(station)}
                >
                  {station.name}
                </MenuItem>
              </Tooltip>
            ))}
          </AccordionDetails>
        </Accordion>
        <Divider />
      </>
    );
  }, [fetchStation, history, stationCodes.stations]);

  return (
    <div id="header">
      <AppBar className={classNames(styles.locqHeaderContainer)}>
        <Toolbar disableGutters>
          <div className={styles.logoContainer}>
            <Image src={StocqLogo} className={styles.logo} />
          </div>
          <div className={styles.toolbarContainer}>
            <Typography variant="h6" className={styles.title}>
              {locale.stocqBOS} - {station.name}
            </Typography>
            <div className={styles.menuContainer}>
              <IconButton
                className={styles.profileDiv}
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleOpen}
              >
                <Image src={DefaultProfile} className={styles.profile} />
                <KeyboardArrowDownRoundedIcon className={styles.caretIcon} />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                keepMounted
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
                className={styles.menu}
              >
                <UserSwitchStations />
                <MenuItem onClick={logoutCb}>{locale.logout}</MenuItem>
              </Menu>
            </div>
          </div>
        </Toolbar>
      </AppBar>
    </div>
  );
};

export default Header;
